var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2261 2.25H7.22607C4.60607 2.25 2.47607 4.38 2.47607 7C2.47607 7.41 2.81607 7.75 3.22607 7.75C3.63607 7.75 3.97607 7.41 3.97607 7C3.97607 5.21 5.43607 3.75 7.22607 3.75H17.2261C19.0161 3.75 20.4761 5.21 20.4761 7V17C20.4761 18.79 19.0161 20.25 17.2261 20.25H7.22607C5.43607 20.25 3.97607 18.79 3.97607 17C3.97607 16.59 3.63607 16.25 3.22607 16.25C2.81607 16.25 2.47607 16.59 2.47607 17C2.47607 19.62 4.60607 21.75 7.22607 21.75H17.2261C19.8461 21.75 21.9761 19.62 21.9761 17V7C21.9761 4.38 19.8461 2.25 17.2261 2.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.47607 11.9999C2.47607 12.4099 2.81607 12.7499 3.22607 12.7499H14.4161L11.6961 15.4699C11.4061 15.7599 11.4061 16.2399 11.6961 16.5299C11.8461 16.6799 12.0361 16.7499 12.2261 16.7499C12.4161 16.7499 12.6061 16.6799 12.7561 16.5299L16.7561 12.5299C17.0461 12.2399 17.0461 11.7599 16.7561 11.4699L12.7561 7.46994C12.4661 7.17994 11.9861 7.17994 11.6961 7.46994C11.4061 7.75994 11.4061 8.23994 11.6961 8.52994L14.4161 11.2499H3.22607C2.81607 11.2499 2.47607 11.5899 2.47607 11.9999Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout_icon.0f7abbf046b04a908c0760d3e1f5412e.svg";
export { ForwardRef as ReactComponent };